export const suckFields = fields => record => {
  const obj = {};
  fields.forEach(
    f => (obj[f] = `${record.querySelector(f)?.textContent || ""}`.trim()),
  );
  return obj;
};
